export const PORTFOLIO_CREATED = "PORTFOLIO_CREATED";
export const PORTFOLIO_UPDATED = "PORTFOLIO_UPDATED";
export const PORTFOLIO_DELETED = "PORTFOLIO_DELETED";
export const PORTFOLIO_RECALCULATED = "PORTFOLIO_RECALCULATED";
export const TRANSACTION_CREATED = "TRANSACTION_CREATED";
export const MULTIPLE_TRANSACTIONS_CREATED = "MULTIPLE_TRANSACTIONS_CREATED";
export const TRANSACTION_DELETED = "TRANSACTION_DELETED";
export const PWA_INSTALL_ACCEPTED = "PWA_INSTALL_ACCEPTED";
